// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"9096be17","854":"f86cf049"}[chunkId] + ".chunk.js";
};